<template>
    <div>
        <div @click="toggleShow()" class="text-center text-red cursor shoesizes">
            <i class="fa fa-table mr-2"></i> {{ $translate("Bigtex5::Template.singleShoeSizesOpen") }}
        </div>
        <div class="schuh-slidein" :class="{'open' : show}">
            <div class="text-right mb-3 cursor" @click="toggleShow()"> Schliessen<i class="fa fa-times-circle ml-2"></i></div>
            <div class="position-relative">
                <template v-if="loading === true">
                    <div class="d-flex justify-content-center loading-table-data">
                        <div class="spinner-border text-primary" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </template>
                <table class="table table-bordered">
                    <tr>
                        <th :class="{'highlight' : highlightIndex === 0}">D</th>
                        <th :class="{'highlight' : highlightIndex === 1}">UK</th>
                        <th :class="{'highlight' : highlightIndex === 2}">US</th>
                        <th :class="{'highlight' : highlightIndex === 3}">CM</th>
                    </tr>
                    <tr v-for="result in jsonResult" @click="selectAttribute(result)">
                        <td :class="{'highlight' : highlightIndex === 0}">
                            <template v-if="result.D !== 0">
                                {{ result.D }}
                            </template>
                            <template v-else>
                                k.A.
                            </template>
                        </td>
                        <td :class="{'highlight' : highlightIndex === 1}">
                            <template v-if="result.UK !== 0">
                                {{ result.UK }}
                            </template>
                            <template v-else>
                                k.A.
                            </template>
                        </td>
                        <td :class="{'highlight' : highlightIndex === 2}">
                            <template v-if="result.US !== 0">
                                {{ result.US }}
                            </template>
                            <template v-else>
                                k.A.
                            </template>
                        </td>
                        <td :class="{'highlight' : highlightIndex === 3}">
                            <template v-if="result.cm !== 0">
                                {{ result.cm }}
                            </template>
                            <template v-else>
                                k.A.
                            </template>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    export default
    {
        data: function()
        {
            return {
                attributes:null,
                jsonResult:null,
                tableKey:null,
                show:false,
                loading:false,
                highlightIndex:-1
            }
        },
        inject:
        {
            itemId:
            {
                default: null
            }
        },
        mounted()
        {
            let _self = this;
            this.$nextTick(() => {
                _self.getJsonFile();
            })

        },
        methods:
            {
                toggleShow: function()
                {
                    let _self = this;
                    if(_self.show === true)
                    {
                        _self.show = false;
                    }
                    else
                    {
                        _self.show = true;
                    }
                },
                selectAttribute: function(data)
                {
                    let _self = this;
                    _self.loading = true;
                    ceresStore.dispatch(`${this.itemId}/loadVariation`, data.variation.variationId).then(variation =>
                    {
                        _self.loading = false;
                        ceresStore.commit(`${this.itemId}/variationSelect/selectItemAttribute`,
                            {
                                attributeId: data.variation.attributes[0].attributeId,
                                attributeValueId:data.variation.attributes[0].attributeValueId
                            });
                        _self.show = false;
                    });
                },
                currentVariation: function()
                {
                    return ceresStore.getters[`${this.itemId}/currentItemVariation`];
                },
                getJsonFile:function()
                {
                    let _self             = this;
                    let variations        = ceresStore.state.items[`${this.itemId}`].variationSelect.variations;

                    let url = '/layout/callisto_3/jsons/json_neu.json'
                    if(ceresStore.getters.currentItemVariation.item.free11!="")
                    {
                        url = '/layout/callisto_3/jsons/'+ceresStore.getters.currentItemVariation.item.free11+'.json';
                    }

                    $.ajax(
                        {
                            type: 'GET',
                            url: url,
                            success: function (data)
                            {
                                _self.tableKey      = data[0];
                                data.shift();
                                _self.jsonResult    = [];


                                for(let i = 0; i<data.length; i++)
                                {
                                    for(let i2 = 0; i2<variations.length; i2++)
                                    {
                                        if(data[i][_self.tableKey.primary] == variations[i2].attributes[0].name)
                                        {

                                            data[i].variation = variations[i2];
                                            _self.jsonResult.push(data[i]);
                                        }
                                    }
                                }
                                let entries = Object.entries(_self.jsonResult[0]);
                                for(let i3 = 0; i3 < entries.length; i3++)
                                {
                                  if(entries[i3][0] == _self.tableKey.primary)
                                  {
                                    _self.highlightIndex = i3;
                                  }
                                }

                            }
                        });
                                   /*         console.log(ceresStore.state.items[`${this.itemId}`].variationSelect);*/
                    let values            = ceresStore.state.items[`${this.itemId}`].variationSelect.attributes[0].values;

                    let activeVars        = [];

                    for(let i = 0; i < variations.length; i++)
                    {
                        if(variations[i].isSalable === true)
                        {
                            activeVars.push(variations[i])
                        }
                    }
                    for(let i2 = 0; i2 < activeVars.length; i2++)
                    {
                        for(let i3 = 0; i3 < values.length; i3++)
                        {
                            if(activeVars[i2].attributes[0].attributeValueId === values[i3].attributeValueId)
                            {
                                activeVars[i2].attributes[0].name = values[i3].name
                            }
                        }
                    }

                    _self.attributes    = activeVars;
                }
            }
    }
</script>
